import { Pipe, PipeTransform } from '@angular/core';
import { EFormService } from '../e-forms/e-form.service';

@Pipe({
  name: 'formatEFormControlType'
})
export class FormatEFormControlTypePipe implements PipeTransform {

  constructor(private eFormService: EFormService) { }
    transform(type): string {
        return this.eFormService.formatControlType(type);
    }

}
